// extracted by mini-css-extract-plugin
export default {"background_pic":"MerchantDetail_background_pic__3WZ72"};